import React from 'react';
import { EventCategoryPage } from '../../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../../data/eventCategoryData';
const Virtual = () => <EventCategoryPage config={EVENT_CATEGORIES['book-clubs-virtual']} data-id="element-9152" data-mp="2ytzalc6kh56q" />;
export default Virtual;